// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module__card___edZpg"};